import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStageCapacityDevelopment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_74_151)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M55.3334 57.2532C57.4542 57.2532 59.1734 55.534 59.1734 53.4132C59.1734 51.2925 57.4542 49.5732 55.3334 49.5732C53.2126 49.5732 51.4934 51.2925 51.4934 53.4132C51.4934 55.534 53.2126 57.2532 55.3334 57.2532Z",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.6667 38.5866L59.7867 42.2933C59.9937 42.8998 60.4121 43.4114 60.9655 43.7346C61.5189 44.0578 62.1701 44.171 62.8 44.0533L66.56 43.1733C67.2714 43.0123 68.0156 43.0834 68.6836 43.3761C69.3516 43.6688 69.9083 44.1678 70.272 44.7999C70.6358 45.4321 70.7875 46.1641 70.705 46.8887C70.6225 47.6134 70.31 48.2925 69.8134 48.8266L67.1467 51.68C66.7335 52.163 66.5065 52.7777 66.5065 53.4133C66.5065 54.0489 66.7335 54.6636 67.1467 55.1466L69.8134 58C70.31 58.5341 70.6225 59.2132 70.705 59.9379C70.7875 60.6625 70.6358 61.3946 70.272 62.0267C69.9083 62.6588 69.3516 63.1578 68.6836 63.4505C68.0156 63.7433 67.2714 63.8143 66.56 63.6533L62.8 62.8C62.1735 62.6808 61.525 62.7901 60.9721 63.1081C60.4192 63.4262 59.9987 63.9318 59.7867 64.5333L58.6667 68.24C58.4627 68.9452 58.0352 69.565 57.4484 70.0061C56.8616 70.4472 56.1474 70.6857 55.4134 70.6857C54.6793 70.6857 53.9651 70.4472 53.3783 70.0061C52.7915 69.565 52.364 68.9452 52.16 68.24L50.9334 64.5333C50.7584 63.9244 50.3569 63.4055 49.8115 63.0832C49.266 62.7608 48.6178 62.6595 48 62.8L44.24 63.6533C43.5287 63.8143 42.7845 63.7433 42.1165 63.4505C41.4485 63.1578 40.8918 62.6588 40.528 62.0267C40.1642 61.3946 40.0125 60.6625 40.0951 59.9379C40.1776 59.2132 40.4901 58.5341 40.9867 58L43.6534 55.1466C44.0665 54.6636 44.2935 54.0489 44.2935 53.4133C44.2935 52.7777 44.0665 52.163 43.6534 51.68L40.9867 48.8266C40.4901 48.2925 40.1776 47.6134 40.0951 46.8887C40.0125 46.1641 40.1642 45.4321 40.528 44.7999C40.8918 44.1678 41.4485 43.6688 42.1165 43.3761C42.7845 43.0834 43.5287 43.0123 44.24 43.1733L48 44.0533C48.6259 44.164 49.2708 44.0475 49.8184 43.7248C50.366 43.4021 50.7803 42.8945 50.9867 42.2933L52.1334 38.5866C52.3293 37.8704 52.7551 37.2385 53.3453 36.788C53.9356 36.3375 54.6575 36.0935 55.4 36.0935C56.1425 36.0935 56.8645 36.3375 57.4547 36.788C58.0449 37.2385 58.4708 37.8704 58.6667 38.5866Z",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 26.4534V60C20 60.3537 20.1405 60.6928 20.3905 60.9428C20.6406 61.1929 20.9797 61.3334 21.3333 61.3334H33.3333",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60 26.4534V30.6667",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33337 36.0001L38.48 9.92007C38.8994 9.5489 39.44 9.34399 40 9.34399C40.56 9.34399 41.1007 9.5489 41.52 9.92007L70.6667 36.0001",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.6667 22.6667H37.3333C36.597 22.6667 36 23.2637 36 24.0001V29.3334C36 30.0698 36.597 30.6667 37.3333 30.6667H42.6667C43.403 30.6667 44 30.0698 44 29.3334V24.0001C44 23.2637 43.403 22.6667 42.6667 22.6667Z",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_74_151",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			fill: "white",
			transform: "translate(8 8)"
		})
	}) })]
});
export default SvgIconStageCapacityDevelopment;
